import { useEffect, useState } from "react";
import { useGetAssignmentMarksQuery } from "../../../features/AssignmentMark/assignmentMarkApi";
import { useGetQuizMarksQuery } from "../../../features/QuizMark/quizMarkApi";
import useProcessLeaderboard from "../../../hooks/useProcessLeaderboard";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/Auth/selectAuth";

export default function LeaderBoardTable() {
  const [ownMark, setOwnMark] = useState(null);
  const [maximumNumOfRanks, setMaximumNumOfRank] = useState(null);
  const loggedInUser = useSelector(selectUser);
  const { data: quizMarks } = useGetQuizMarksQuery();
  const { data: assignmentMarks } = useGetAssignmentMarksQuery();
  const rankedData = useProcessLeaderboard(quizMarks, assignmentMarks);

  function setOwnMarkValue() {
    const ownMark = rankedData?.find(
      (mark) => mark.student_id === loggedInUser.student_id
    );
    setOwnMark(ownMark);
  }

  function setMaximumRank() {
    const maxNumberOfMarks = [];
    for (let i = 0; i < rankedData.length; i++) {
      if (rankedData[i].rank > 20) {
        break;
      }
      maxNumberOfMarks.push(rankedData[i]);
    }
    setMaximumNumOfRank(maxNumberOfMarks);
  }

  useEffect(() => {
    if (rankedData) {
      setOwnMarkValue();
      setMaximumRank();
    }
  }, [loggedInUser, rankedData?.length]);

  return (
    <>
      <div>
        <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
        <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
          <thead>
            <tr>
              <th className="table-th !text-center">Rank</th>
              <th className="table-th !text-center">Name</th>
              <th className="table-th !text-center">Quiz Mark</th>
              <th className="table-th !text-center">Assignment Mark</th>
              <th className="table-th !text-center">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-2 border-cyan">
              <td className="table-td text-center font-bold">
                {ownMark?.rank}
              </td>
              <td className="table-td text-center font-bold">
                {ownMark?.name}
              </td>
              <td className="table-td text-center font-bold">
                {ownMark?.quizMark}
              </td>
              <td className="table-td text-center font-bold">
                {ownMark?.assignmentMark}
              </td>
              <td className="table-td text-center font-bold">
                {ownMark?.totalMark}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="my-8">
        <h3 className="text-lg font-bold">Top 20 Result</h3>
        <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
          <thead>
            <tr className="border-b border-slate-600/50">
              <th className="table-th !text-center">Rank</th>
              <th className="table-th !text-center">Name</th>
              <th className="table-th !text-center">Quiz Mark</th>
              <th className="table-th !text-center">Assignment Mark</th>
              <th className="table-th !text-center">Total</th>
            </tr>
          </thead>
          <tbody>
            {maximumNumOfRanks?.map((mark) => (
              <tr
                className="border-b border-slate-600/50"
                key={mark.student_id}
              >
                <td className="table-td text-center">{mark.rank}</td>
                <td className="table-td text-center">{mark.name}</td>
                <td className="table-td text-center">{mark.quizMark}</td>
                <td className="table-td text-center">{mark.assignmentMark}</td>
                <td className="table-td text-center">{mark.totalMark}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
